// 한 번에 불러올 수 있는 사용자 목록 사이즈
export const MAX_USER_PAGE_SIZE = 10000;
// 한 번에 불러올 수 있는 그룹 목록 사이즈
export const MAX_GROUP_PAGE_SIZE = 10000;

// 개인정보 처리방침 약관을 식별할 수 있는 다국어 대응 텍스트. 슈퍼어드민 약관관리에서 변경시 이쪽에도 추가하거나 해야 함. 아니면 슈퍼어드민 약관관리에서 여기 텍스트에 맞춰서 약관 등록 해줘야.
export const TERMS_PRIVACY_POLICY_TITLES = ['개인정보 처리방침', '개인정보처리방침', 'Privacy Policy', 'Privacy policy'];

// 도메인이 여러개일 수 있는 사이트가 있어서 대응하기 위해 추가
export const COMMON_API_HOST = process.env.PUBLIC_COMMON_API_HOST || (typeof window !== 'undefined' ? window.location.origin : '');

/**
 * 프로모션 모달 오늘 하루 보지 않기 기능 관리 쿠키 이름
 */
export const PROMOTION_EVENT_MODAL_COOKIE_NAME = 'promotionEventModal_hideUntil';
